import { useEffect, useState } from "react";
import { memberApi } from "../lib/api";
import { toast } from "sonner";

const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} $`;

// Frais d'inscription / renouvellement : bouton « Payer » → lien Stripe direct. Montant 30 $ (≤ 28 j après fin de contrat) ou 40 $ (+ taxes).
export default function MemberFeeButton() {
  const [fee, setFee] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => memberApi.get("/member/fee").then((r) => setFee(r.data)).catch(() => setFee(null));
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get("fee") === "ok") { toast.success("Paiement reçu — merci ! Tes frais seront confirmés dans quelques instants."); window.history.replaceState({}, "", window.location.pathname); }
    if (p.get("fee") === "annule") { toast.info("Paiement annulé — tu peux réessayer quand tu veux."); window.history.replaceState({}, "", window.location.pathname); }
    load();
  }, []);

  const pay = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await memberApi.post("/member/fee/checkout", { origin: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Impossible d'ouvrir le paiement"); setBusy(false); }
  };

  if (!fee || !fee.applicable) return null;
  const paid = fee.status === "paye";
  const isRenewal = fee.kind === "renouvellement";

  return (
    <section className={`border p-5 mb-8 kz-fade-up ${paid ? "border-emerald-500/40 bg-emerald-500/10" : "border-amber-500/50 bg-amber-500/10"}`} data-testid="member-fee-section">
      <p className="kz-mono text-[10px] tracking-[0.26em] uppercase text-white/40">{isRenewal ? "Renouvellement de contrat" : "Frais d'inscription"}</p>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-1">
        <div>
          <h2 className="kz-display text-2xl" data-testid="member-fee-label">{fee.label}</h2>
          <p className="text-white/60 text-sm mt-1" data-testid="member-fee-hint">{paid ? `Payés ✓${fee.paid_at ? ` le ${String(fee.paid_at).slice(0, 10)}` : ""}${fee.method ? ` (${fee.method})` : ""}` : fee.hint}</p>
          {!paid && <p className="text-white/40 text-xs mt-1">Détail : {money(fee.base)} + TPS {money(fee.tps)} + TVQ {money(fee.tvq)} = <b className="text-white/80">{money(fee.total)}</b></p>}
          {isRenewal && fee.renewal?.late && !paid && <p className="text-rose-300 text-xs mt-1" data-testid="member-fee-late">Tarif après {fee.renewal.delay_days} jours appliqué.</p>}
        </div>
        {!paid && (
          <button onClick={pay} disabled={busy} data-testid="member-fee-pay-btn"
            className="bg-[#D90429] hover:bg-white hover:text-[#0A0A0A] disabled:opacity-40 px-6 py-3 font-semibold transition-colors whitespace-nowrap">
            {busy ? "Ouverture de Stripe…" : `Payer ${money(fee.total)} maintenant`}
          </button>
        )}
      </div>
    </section>
  );
}
